import { getPath } from './get-path.js';
import { setPath } from './set-path.js';
function removePath(path, index, values) {
  var currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  return setPath(path, currentValue.filter(function (_, itemIndex) {
    return itemIndex !== index;
  }), values);
}
export { removePath };